const styles = theme => ({
    root: {
        height: 56,
        marginBottom: 36
    }
});

export default styles;